import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath, storagePath } from '../../constants/defaultValues';
import { storage } from '../../helpers/Firebase';
import { NotificationManager } from '../../components/common/react-notifications';
import {
    SPE_PURCHASE_ORDER,
    SPE_SUPPLIER,
    SPE_CATEGORY,
    SPE_PURCHASE_ORDER_STATUS,
    SPE_USER_ROLE,
    PO_SPE_LIST,
    SPE_ADD_COMITE,
    SPE_CHECKLIST,
    SPE_EVALUATION_OPTION,
    SPE_ADD_EVALUATION,
    SPE_CLOSED_EVALUATION,
    SPE_CHECKLIST_SCORE,
    SPE_EDIT_COMITE
} from "../actions";

import {
    SPEPurchaseOrderSuccess,
    SPEPurchaseOrderError,
    SPESupplierSuccess,
    SPESupplierError,
    SPECategorySuccess,
    SPECategoryError,
    SPEUserRoleSuccess,
    SPEUserRoleError,
    SPEPurchaseOrderStatusSuccess,
    SPEPurchaseOrderStatusError,
    POSPEListSuccess,
    POSPEListError,
    SPEAddComiteSuccess,
    SPEAddComiteError,
    SPEChecklistSuccess,
    SPEChecklistError,
    SPEEvaluationOptionSuccess,
    SPEEvaluationOptionError,
    SPEAddEvaluationSuccess,
    SPEAddEvaluationError,
    SPEClosedEvaluationSuccess,
    SPEClosedEvaluationError,
    SPEChecklistScoreSuccess,
    SPEChecklistScoreError,
    SPEEditComiteSuccess,
    SPEEditComiteError,
} from '../actions';

export function* watchSPEPurchaseOrder() {
    yield takeEvery(SPE_PURCHASE_ORDER, onSPEPurchaseOrder);
}

export function* watchSPESupplier() {
    yield takeEvery(SPE_SUPPLIER, onSPESupplier);
}

export function* watchSPECategory() {
    yield takeEvery(SPE_CATEGORY, onSPECategory);
}

export function* watchSPEUserRole() {
    yield takeEvery(SPE_USER_ROLE, onSPEUserRole);
}

export function* watchSPEPurchaseOrderStatus() {
    yield takeEvery(SPE_PURCHASE_ORDER_STATUS, onSPEPurchaseOrderStatus);
}

export function* watchSPEEvaluationOption() {
    yield takeEvery(SPE_EVALUATION_OPTION, onSPEEvaluationOption);
}

export function* watchPOSPEList() {
    yield takeEvery(PO_SPE_LIST, onPOSPEList);
}

export function* watchSPEAddComite() {
    yield takeEvery(SPE_ADD_COMITE, onSPEAddComite);
}

export function* watchSPEChecklist() {
    yield takeEvery(SPE_CHECKLIST, onSPEChecklist);
}

export function* watchSPEAddEvaluation() {
    yield takeEvery(SPE_ADD_EVALUATION, onSPEAddEvaluation);
}

export function* watchSPEClosedEvaluation() {
    yield takeEvery(SPE_CLOSED_EVALUATION, onSPEClosedEvaluation);
}

export function* watchSPEChecklistScore() {
    yield takeEvery(SPE_CHECKLIST_SCORE, onSPEChecklistScore);
}

export function* watchSPEEditComite() {
    yield takeEvery(SPE_EDIT_COMITE, onSPEEditComite);
}
function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onSPEPurchaseOrderAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'speTool/purchaseorder', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSPESupplierAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'speTool/supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSPECategoryAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'speTool/category', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSPEUserRoleAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'speTool/userrole', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSPEPurchaseOrderStatusAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'speTool/purchaseorderstatus', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSPEEvaluationOptionAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'speTool/evaluationoption', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onPOSPEListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'speTool/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
}

const onSPEAddComiteAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'speTool/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSPEChecklistAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'speTool/checklist', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSPEAddEvaluationAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'speTool/addevaluation', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSPEClosedEvaluationAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'speTool/closedevaluation', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSPEChecklistScoreAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'speTool/score', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSPEEditComiteAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'speTool/editcomite', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

function* onSPEPurchaseOrder(data) {
    try {
        const response = yield call(onSPEPurchaseOrderAsync, data.payload);
        yield put(SPEPurchaseOrderSuccess(response.data));
    } catch (error) {
        yield put(SPEPurchaseOrderError(error));
    }
}

function* onSPESupplier(data) {
    try {
        const response = yield call(onSPESupplierAsync, data.payload);
        yield put(SPESupplierSuccess(response.data));
    } catch (error) {
        yield put(SPESupplierError(error));
    }
}

function* onSPECategory(data) {
    try {
        const response = yield call(onSPECategoryAsync, data.payload);
        yield put(SPECategorySuccess(response.data));
    } catch (error) {
        yield put(SPECategoryError(error));
    }
}

function* onSPEUserRole(data) {
    try {
        const response = yield call(onSPEUserRoleAsync, data.payload);
        yield put(SPEUserRoleSuccess(response.data));
    } catch (error) {
        yield put(SPEUserRoleError(error));
    }
}

function* onSPEPurchaseOrderStatus(data) {
    try {
        const response = yield call(onSPEPurchaseOrderStatusAsync, data.payload);
        yield put(SPEPurchaseOrderStatusSuccess(response.data));
    } catch (error) {
        yield put(SPEPurchaseOrderStatusError(error));
    }
}

function* onSPEEvaluationOption(data) {
    try {
        const response = yield call(onSPEEvaluationOptionAsync, data.payload);
        yield put(SPEEvaluationOptionSuccess(response.data));
    } catch (error) {
        yield put(SPEEvaluationOptionError(error));
    }
}

function* onPOSPEList(data) {
    try {
        const response = yield call(onPOSPEListAsync, data.payload);
        yield put(POSPEListSuccess(response.data));
    } catch (error) {
        yield put(POSPEListError(error));
    }
}

function* onSPEAddComite(data) {
    try {
        const response = yield call(onSPEAddComiteAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(SPEAddComiteSuccess(response.data));
    } catch (error) {
        yield put(SPEAddComiteError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onSPEChecklist(data) {
    try {
        const response = yield call(onSPEChecklistAsync, data.payload);
        yield put(SPEChecklistSuccess(response.data));
    } catch (error) {
        yield put(SPEChecklistError(error));
    }
}

function* onSPEAddEvaluation(data) {
    try {
        const response = yield call(onSPEAddEvaluationAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(SPEAddEvaluationSuccess(response.data));
    } catch (error) {
        yield put(SPEAddEvaluationError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onSPEClosedEvaluation(data) {
    try {
        const response = yield call(onSPEClosedEvaluationAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(SPEClosedEvaluationSuccess(response.data));
    } catch (error) {
        yield put(SPEClosedEvaluationError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onSPEChecklistScore(data) {
    try {
        const response = yield call(onSPEChecklistScoreAsync, data.payload);
        yield put(SPEChecklistScoreSuccess(response.data));
    } catch (error) {
        yield put(SPEChecklistScoreError(error));
    }
}

function* onSPEEditComite(data) {
    try {
        const response = yield call(onSPEEditComiteAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(SPEEditComiteSuccess(response.data));
    } catch (error) {
        yield put(SPEEditComiteError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchSPEPurchaseOrder),
        fork(watchSPESupplier),
        fork(watchSPECategory),
        fork(watchSPEEvaluationOption),
        fork(watchSPEUserRole),
        fork(watchSPEPurchaseOrderStatus),
        fork(watchPOSPEList),
        fork(watchSPEAddComite),
        fork(watchSPEChecklist),
        fork(watchSPEAddEvaluation),
        fork(watchSPEClosedEvaluation),
        fork(watchSPEChecklistScore),
        fork(watchSPEEditComite)
    ]);
}